import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import ChapterHeader from '../ChapterHeader/ChapterHeader';
import FloatingCubes from '../FloatingCubes/FloatingCubes';
import imageS from '../../assets/ch1-m.png';
import imageWebP from '../../assets/ch1-m.webp';

function Chapter1() {
  const hyperlinkData = [
    {
      copy: 'U.S. Centers for Disease Control and Prevention',
      href: 'https://www.cdc.gov/chronicdisease/programs-impact/pop/colorectal-cancer.htm#:~:text=Almost%2088%25%20of%20adults%20diagnosed,diagnosed%20with%20late%2Dstage%20cancer.&text=REDUCE%20health%20care%20spending.,by%20%2414%20billion*%20in%202050.',
      label: 'Visit CDC page, Health and Economic Benefits of Colorectal Cancer Interventions'
    }
  ];
  return (
    <section className="chapters">
      <ChapterHeader chIndex={0} />
      <div className="chapters__body">
        <FloatingCubes origin="ch1" />
        <h3 className="chapters__head">
          <span className="chapters__head__number">1</span>
          <span className="chapters__head__copy">Saving Lives with Early Cancer Detection</span>
        </h3>

        <p>
          It cannot be stated often enough or loudly enough: Early detection of nearly every type of
          cancer can improve outcomes and save lives. For example, the{' '}
          <Hyperlink hyperlinkData={hyperlinkData[0]} /> (CDC) estimates that nearly 88% of adults
          who receive an early-stage diagnosis of colorectal cancer live for 5 years or more
          compared with 16% of those diagnosed at a late stage.
        </p>
        <p>
          <span className="bluebold">
            Cancer research is one of the most impactful use cases for artificial intelligence today
          </span>
          , but like any other AI application, its success depends on the scale and depth of
          relevant data. A significant factor working against AI-driven cancer research at scale has
          been the confidential nature of patient data. However, Intel Labs and a leading medical
          university have devised a novel solution with the help of Federated Learning.
        </p>
        <div className="chapters__photoS chapters__photoS-1">
          <picture>
            <source srcSet={imageWebP} />
            <source srcSet={imageS} />
            <img src={imageS} alt="" />
          </picture>
        </div>
        <p>
          This international collaboration brought an unprecedented 71 institutions across six
          continents together, through a decentralized system using Intel Federated Learning and
          Software Guard Extensions. In a Federated Learning model, organizations can
          cross-reference updates from local data without sharing the data itself, meaning
          researchers gain the value of patients’ medical information without compromising their
          privacy. “By capturing learnings from data silos, Federated Learning can both improve
          existing use cases through increased data volume and diversity, as well as open up
          entirely new uses that were infeasible due to lack of training data,” says Intel Labs'
          Senior Researcher Micah Sheller.
        </p>
        <p>
          The result:{' '}
          <span className="bluebold">
            an incredible 33% improvement in brain tumor detection based on MRI scans from more than
            6,300 patients
          </span>
          . Other healthcare researchers can immediately benefit from this study through Intel’s
          open-source OpenFL project, which will allow anyone to deploy their own cross-silo
          Federated Learning applications with SGX. “I am honored to be working alongside medical AI
          researchers,” says Sheller. “Seeing our technology empower their efforts toward the common
          good excites me for the future of Federated Learning.”
        </p>
      </div>
    </section>
  );
}

export default Chapter1;
